module.exports = __webpack_public_path__ + "img/web-coding.4d6de283.svg";